import * as React from "react";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./DanfePdfPage.css";
import DanfeFirstPage from "../../components/danfepdf/DanfeFirstPage";
import DanfeNextPage from "../../components/danfepdf/DanfeNextPage";
import { useTranslation } from "react-i18next";
import { fetchFileXml } from "../../services/fileXmlService";
import { parseNfeXml } from "../../utilities/Utilities";
import { mapParsedNfeToDanfeData } from "../../utilities/mapParsedNfeToDanfeData";

const DanfePdfPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { accessKey } = useParams();

  const [data, setData] = React.useState(location.state?.data || null);
  const [loading, setLoading] = React.useState(!location.state?.data);

  React.useEffect(() => {
    async function loadDanfe() {
      try {
        if (data) {
          setLoading(false);
          return;
        }

        if (!accessKey) {
          setLoading(false);
          return;
        }

        const result = await fetchFileXml(accessKey);

        if (!result?.xml) {
          setLoading(false);
          return;
        }

        const parsedXml = parseNfeXml(result.xml, t);
        const mapped = mapParsedNfeToDanfeData(parsedXml);

        setData(mapped);
      } catch (error) {
        console.error("Erro ao carregar DANFE:", error);
      } finally {
        setLoading(false);
      }
    }

    loadDanfe();
  }, [accessKey, data, t]);

  if (loading) {
    return (
      <Box sx={{ p: 2 }}>
        Carregando DANFE...
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ p: 2 }}>
        Dados da DANFE não encontrados.
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, backgroundColor: "#f0f0f0", minHeight: "100vh" }}>
      <Box
        className="danfe-no-print"
        sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}
      >
        <Button
          variant="outlined"
          onClick={() => navigate(-1)}
          sx={{ textTransform: "none" }}
        >
          {t("buttons.bClose")}
        </Button>
        <Button
          variant="contained"
          onClick={() => window.print()}
          sx={{ textTransform: "none" }}
        >
          {t("buttons.bpdf")}
        </Button>
      </Box>

      <DanfeFirstPage data={data} folha={`1/${data.itemsPages.length}`} />

      {data.itemsPages.slice(1).map((items, index) => (
        <DanfeNextPage
          key={index}
          data={data}
          folha={`${index + 2}/${data.itemsPages.length}`}
          items={items}
        />
      ))}
    </Box>
  );
};

export default DanfePdfPage;